/**
 * user有两种订阅模式
 * 1、on("success",fun) 表示成功
 * 2、on("fail",fun)  表示失败
 */

import Vue from "vue";

var SAVE_KEY = "_userinfo",
    COOKIE_KEY = "kdy_userid",
    user = new EventEmitter({
        http: Vue.prototype.$http,
        info: getUserInfo(),
        login: function (api, data) {
            var _this = this;
            this.http.post(api, data).then(function (res) {
                var j = res.data;
                if (j.code === 200) {
                    j.data.time = new Date().getTime();
                    localStorage.setItem(SAVE_KEY, JSON.stringify(j.data));
                    localStorage.setItem("time", new Date().getTime());
                    _this.info = j.data;
                    _this.emit("success", j.data);
                }
                else {
                    _this.emit("fail", j.error);
                }
            }, function () {
                _this.emit("fail", "系统出错");
            });
            return this;
        },
        logout: function (cb) {
            var _this = this;
            this.http.get("api/logout").then(function (res) {
                _this.info = null;
                localStorage.removeItem(SAVE_KEY);
                var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
				if(keys) {
					for(var i = keys.length; i--;)
						document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString()
				}

                cb && cb();
            }, function (err) {
            });
        },
        pointLogin(data) {
            var _this = this;
            localStorage.setItem(SAVE_KEY, JSON.stringify(data));
            localStorage.setItem("time", new Date().getTime());
            _this.info=data;
            console.log("设置成功！")
        }
    });
function setTime() {

}
function getUserInfo() {

    var userinfo, time;
    var exp = 3600 * 6 * 1000;



    userinfo = localStorage.getItem("_userinfo");
    time = localStorage.getItem("time");
    if (userinfo) {

        userinfo = JSON.parse(userinfo);
        if (new Date().getTime() - userinfo.time > exp) {

            localStorage.removeItem("_userinfo");

        } else {

            return userinfo;

        }
    } else {
        return false;
    }
    // }
    return null;
}

export default user;



// WEBPACK FOOTER //
// ./src/components/login/user.js